import { Premium } from '@components/hub/player/Premium';
import { useTranslation, Trans } from 'react-i18next';
import { FancyCard } from '@components/ui/FancyCard';
import { TextInput } from '@components/ui/TextInput';
import { Button } from '@components/ui/Button';
import { useFreeZenithMutation } from '@http';
import { toast } from 'react-toastify';
import { useAppStore } from '@stores';
import { useState } from 'react';

export function GetZenith() {
  const [showReddit, setShowReddit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [redditUrl, setRedditUrl] = useState('');

  const { t } = useTranslation(undefined, { keyPrefix: 'Capsules.Zenith' });
  const { mutateAsync } = useFreeZenithMutation();
  const { refetch } = useAppStore();

  const isValidReddit = redditUrl.startsWith('https://') || redditUrl.includes('reddit.com');

  const submitReddit = async () => {
    if (!isValidReddit || isLoading) return;
    setIsLoading(true);

    await mutateAsync({ url: redditUrl });

    setRedditUrl('');
    setIsLoading(false);
    setShowReddit(false);
    refetch();

    toast(t('submitSuccess'), { type: 'success' });
  };

  return (
    <div className="mb-6">
      <p className="mb-2">{t('title')}</p>
      <Premium />

      <div className="mt-2">
        <FancyCard>
          {!showReddit && (
            <div onClick={() => setShowReddit(true)} className="cursor-pointer">
              <img className="h-24 absolute -right-[15%] -bottom-[75%] opacity-25 -rotate-25" src="/img/icons/reddit.svg" />
              <p className="text-sm slight-active">{t('redditTitle')}</p>
              <p className="text-sm text-gray-400 w-5/6">
                <Trans
                  components={{ r: <span className="slight-active" /> }}
                  i18nKey="redditDescription"
                  t={t}
                />
              </p>
            </div>
          )}

          {showReddit && (
            <div>
              <p className="text-sm slight-active">{t('redditTitle')}</p>
              <p className="text-sm text-gray-400 mb-2">{t('redditDescription2')}</p>
              <TextInput
                className="bg-black border border-secondary"
                onChange={setRedditUrl}
                placeholder={t('link')}
                value={redditUrl}
              />
              <Button
                className="mt-2 btn-active"
                disabled={!isValidReddit}
                onClick={submitReddit}
                isLoading={isLoading}
              >
                {t('submit')}
              </Button>
            </div>
          )}
        </FancyCard>
      </div>
    </div>
  );
}
